import Select, { components } from 'react-select';
import ChevronDown from '@/icons/ChevronDown';
import { ThemeContext } from '@/state/Theme';

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <ChevronDown fill="#737579" />
  </components.DropdownIndicator>
);

const CustomSelect = (props) => {
  const { label } = props;

  return (
    <ThemeContext.Consumer>
      {(theme) => (
        <>
          {label && <label className="heading heading_section">{label}</label>}

          <Select
            components={{
              DropdownIndicator,
            }}
            styles={{
              clearIndicator: (provided) => ({
                ...provided,
                cursor: 'pointer',
              }),
              control: (provided, { isFocused, menuIsOpen }) => ({
                ...provided,
                border:
                  props.borderColor !== undefined
                    ? `1px solid ${props.borderColor}`
                    : '1px solid #e1e1e1',
                borderRadius: '12px',
                borderBottomLeftRadius: menuIsOpen ? 0 : '12px',
                borderBottomRightRadius: menuIsOpen ? 0 : '12px',
                outline: isFocused ? `1px solid ${theme.brandColor}` : null,
                ':hover': {
                  borderColor: theme.brandColor,
                  cursor: 'pointer',
                },
              }),
              dropdownIndicator: (provided) => ({
                ...provided,
                padding: '8px 15px 8px 12px',
              }),
              indicatorSeparator: (provided, { hasValue }) => ({
                ...provided,
                backgroundColor: hasValue ? '#D5D4DC' : '#FFFFFF',
                marginBottom: '16px',
                marginTop: '16px',
              }),
              input: (provided, { hasValue }) => ({
                ...provided,
                fontSize: '18px',
                margin: hasValue ? '0 0 9px' : 0,
                padding: 0,
              }),
              menu: (provided) => ({
                ...provided,
                border: '1px solid #D5D4DC',
                borderBottomLeftRadius: '12px',
                borderBottomRightRadius: '12px',
                borderTop: 0,
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                boxShadow: 'none',
                marginTop: '-1px',
                overflow: 'hidden',
                '::before': {
                  borderTop: '1px solid #E1E1E1',
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: '16px',
                  right: '16px',
                },
              }),
              multiValue: (provided) => ({
                ...provided,
                background: '#EAE9F1',
                borderRadius: '4px',
                margin: '0 6px 9px 0',
                padding: 0,
              }),
              multiValueLabel: (provided) => ({
                ...provided,
                color: '#737579',
                fontSize: '16px',
                lineHeight: 1,
                padding: '8px 5px 8px 10px',
                paddingLeft: '10px',
              }),
              multiValueRemove: (provided) => ({
                ...provided,
                cursor: 'pointer',
                padding: '8px',
              }),
              option: (provided, { isFocused }) => ({
                ...provided,
                backgroundColor: isFocused ? theme.brandColor : '#FFFFFF',
                color: isFocused ? '#FFFFFF' : '#737579',
                cursor: 'pointer',
                fontSize: '16px',
                padding: '16px',
                ':active': {
                  backgroundColor: '#FFA13A',
                },
              }),
              placeholder: (provided) => ({
                ...provided,
                color: '#737579',
                fontFamily: '"Calibre", sans-serif',
                fontSize: '18px',
              }),
              valueContainer: (provided, { hasValue }) => ({
                ...provided,
                padding: hasValue ? '11px 15px 2px 15px' : '13px 15px',
              }),
            }}
            {...props}
          />
        </>
      )}
    </ThemeContext.Consumer>
  );
};

export default CustomSelect;
